import _ from '@lodash';
import { TableCell, Tooltip } from '@material-ui/core';
import { withRouter } from 'react-router';

const maxLength = 20;

function TaskManagerLastMessageField(props) {
	const { item } = props;

	const getLabel = (short) => {
		let str = item.lastMessage;
		if (str && short) str = str.substring(0, maxLength) + (str.length > maxLength ? '...' : '');
		return str;
	};

	return (
		<TableCell className='w-auto'>

			<Tooltip title={getLabel()} placement='bottom'>
				<div className='whitespace-nowrap overflow-hidden overflow-ellipsis'>{getLabel(true)}</div>
			</Tooltip>

		</TableCell>
	);
}

export default withRouter(TaskManagerLastMessageField);